import client from '@/store/bss/client';
import plan from '@/store/bss/plan';
import product from '@/store/bss/product';
import $http from '@/module/http';

let pGpuModels = null;
let emailScenes = null;
let pAffiliateOrderInvalidReasons = null;
let pLLMModels = null;
let pSpUnits = null;
let pSpResourceOptions = null;
let pTaxesConfigs = null;
export default {
  strict: true,
  namespaced: true,
  state: {
    gpuModels: [],
    emailScenes: [],
    affiliateOrderInvalidReasons: [],
    specificationUnits: [],
    specificationResourceNames: [],
    specificationResourceOptions: [],
    taxesConfigs: []
  },
  mutations: {
    setGpuModels(state, { results }) {
      state.gpuModels = results;
    },
    setEmailScenes(state, { results }) {
      state.emailScenes = results;
    },
    setAffiliateOrderInvalidReasons(state, { results }) {
      state.affiliateOrderInvalidReasons = results;
    },
    setLLMModels(state, { results }) {
      state.llmModels = results;
    },
    setSpecificationUnits(state, { results }) {
      state.specificationUnits = results;
    },
    setSpecificationResourceNames(state, { results }) {
      state.specificationResourceNames = results;
    },
    setSpecificationResourceOptions(state, { results }) {
      state.specificationResourceOptions = results;
    },
    setTaxesConfigs(state, { results }) {
      state.taxesConfigs = results;
    }
  },
  getters: {
    billingMonth() {
      return (duration) => {
        switch (duration) {
          case 1:
            return 'month';
          case 3:
            return '3 months';
          case 6:
            return '6 months';
          case 12:
            return 'year';
          case 24:
            return '2 years';
          case 36:
            return '3 years';
          case 48:
            return '4 years';
          case 60:
            return '5 years';
        }
      };
    }
  },
  actions: {
    getGpuModels: ({ commit }) => {
      let p = null;
      if (pGpuModels) {
        p = pGpuModels;
      } else {
        p = $http
          .get('system_options/', {
            params: {
              q: 'option_type__inner_name=baremetal_gpu_model,is_active=true'
            }
          })
          .then((res) => {
            commit('setGpuModels', res);
            return res.results;
          })
          .catch(() => {});
        pGpuModels = p;
      }
      return p;
    },
    getEmailScenes: ({ commit }, email_category = '') => {
      let p = null;
      if (emailScenes && !email_category) {
        p = emailScenes;
      } else {
        p = $http
          .get('email_templates/get_templates_scene/?email_category=' + email_category)
          .then((res) => {
            commit('setEmailScenes', res);
            return res;
          })
          .catch(() => {});
        if (!email_category) {
          emailScenes = p;
        }
      }
      return p;
    },
    getAffiliateOrderInvalidReasons: ({ commit }) => {
      let p = null;
      if (pAffiliateOrderInvalidReasons) {
        p = pAffiliateOrderInvalidReasons;
      } else {
        p = $http
          .get('affiliate_order_invalid_reasons/', {
            params: {
              page: 1,
              page_size: 1000
            }
          })
          .then((res) => {
            const results = res.results.map((item) => ({
              id: item.id,
              name: item.display_reason
            }));
            commit('setAffiliateOrderInvalidReasons', results);
            return results;
          })
          .catch(() => {});
        pAffiliateOrderInvalidReasons = p;
      }
      return p;
    },
    getLLMModels: ({ commit }) => {
      let p = null;
      if (pLLMModels) {
        p = pLLMModels;
      } else {
        p = $http.get('llm_models/').then(({ results }) => {
          commit('setLLMModels', results);
          return results;
        });
        pLLMModels = p;
      }
      return p;
    },
    getSpecificationUnits: ({ commit }) => {
      let p = null;
      if (pSpUnits) {
        p = pSpUnits;
      } else {
        p = $http
          .get('system_units/', {
            params: {
              page: 1,
              page_size: 9999
            }
          })
          .then(({ results }) => {
            commit('setSpecificationUnits', { results });
            return results;
          });
        pSpUnits = p;
      }
      return p;
    },
    getSpecificationResourceNames: ({ commit }) => {
      let p = null;

      p = $http
        .get('base_option_types/', {
          params: {
            page: 1,
            page_size: 9999
          }
        })
        .then(({ results }) => {
          commit('setSpecificationResourceNames', { results });
          return results;
        });

      return p;
    },
    getSpecificationResourceOptions: ({ commit }) => {
      let p = null;
      if (pSpResourceOptions) {
        p = pSpResourceOptions;
      } else {
        p = $http
          .get('system_options/', {
            params: {
              page: 1,
              page_size: 9999
            }
          })
          .then(({ results }) => {
            commit('setSpecificationResourceOptions', { results });
            return results;
          });
      }
      pSpResourceOptions = p;
      return p;
    },
    getDynamicFilters: (_, { productLineId }) => {
      return $http
        .get('specifications/get_specification_names/', {
          params: {
            product_line_id: productLineId
          }
        })
        .then((res) => {
          return res;
        })
        .catch(() => {
          this.$message.error('Failed to get dynamic filters');
        });
    },
    getTaxesConfigs: ({ commit }) => {
      let p = null;
      if (pTaxesConfigs) {
        p = pTaxesConfigs;
      } else {
        p = $http.get('taxes/configs/').then((res) => {
          commit('setTaxesConfigs', res);
          return res;
        });
        pTaxesConfigs = p;
      }
      return p;
    }
  },
  modules: { client, plan, product }
};
